import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Autocomplete, Button, CircularProgress, Divider, InputAdornment, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ModalAlert } from '../../../components/modal';
import BasicTable from '../../../components/table';
import { TableBar } from '../../../components/table/styles';
import { api } from '../../../services/axios';
import { AddModal } from './styles';

import Modal from "react-modal";
import { ModalAlertDiv } from '../../../components/modal/style';
import SelectMui from '../../../components/select';
import PercentIcon from '@mui/icons-material/Percent';

const defaultForm = {
  templateList: [{ IdEngTemplate: '', Template: '' }],
  templateValue: '',
  engineType: [''],
  engineTypeValue: '',
  EngDescription: '',
  Limit: '',
  Bonus: '',
  Priority: '',
  Calendar: '',
  template: '',
  transformersValue: [],
  calendarList: [],
  calendarValue: ""
}

const Engines = () => {
  const url = "core/ajax/engines"

  const headers = [
    { label: 'Id', value: 'IdCampEngine' },
    { label: 'Campaign Name', value: 'Campaign' },
    { label: 'Algorithm', value: 'Algorithm' },
    { label: 'Description', value: 'EngDescription' },
    { label: 'Calendar', value: 'Calendar' },
    { label: 'Campaign', value: 'campaignActive' },
    { label: 'Active', value: 'Active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [rows, setRows] = useState({ default: [], filter: [] })
  const [isValidate, setIsValidate] = useState(false)
  const [form, setForm] = useState(defaultForm);
  const [formWeight, setFormWeight] = useState({});

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [id, setId] = useState();


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdCampEngine: Number(e.IdCampEngine),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdCampEngine: Number(e.IdCampEngine),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const validation = () => {
    if (form.templateValue === '' ||
      form.engineTypeValue === '' ||
      form.Limit === '' ||
      form.Bonus === '' ||
      form.Priority === '') {
      setIsValidate(true)
      return false
    } else {
      return true
    }
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxHeight: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',

    }
  };

  const updateForm = (row) => {
    api.post(url, {
      type: 'info',
      id: row.IdCamp.toString(),
      authx: ''
    })
      .then(function (res) {
        setForm({
          ...row,
          Active: Number(row.Active).toString(),
          IdTransformer: res.data?.engine['1'] ? res.data.engine['1']['0'].IdTransformer : '',

          templateList: res.data.combo.templates,
          templateValue: res.data['0'].IdEngTemplate,

          engineType: res.data.combo.types.map((e) => { return { value: e.IdEngAlgorithm, label: e.Algorithm } }),
          engineTypeValue: res.data['0'].IdEngAlgorithm,

          transformers: res.data.combo.transformers,
          transformersValue: res.data?.engine['1'] ? res.data.engine['1']['0'].IdTransformer : '',

          calendarList: res.data.combo.calendars.map((e) => { return { value: e.IdEngineCalendar, label: e.Calendar } }),
          calendarValue: res.data['0'].IdEngineCalendar,

          idEngDirect: res.data?.engine['1'] ? res.data.engine['1']['0'].IdEngDirect : '',
        })
      })
      .catch(function (error) {
        console.log(error);
      });

    setShowModal(true)
    setId(row.IdCampEngine)
  }

  const confirmUpdateForm = () => {
    const url = "core/ajax/providers"
    const newForm = Object.fromEntries(Object.entries(formWeight).filter(([_, v]) => v.Weight !== ''));
    const sumValues = Object.values(newForm).reduce((a, b) => a + Number(b.Weight), 0);

    if (form.engineTypeValue === '1') {
      api.post('core/ajax/campaigns', {
        data0: JSON.stringify({
          Active: form.Active, // Não tem alteração
          IdEngAlgorithm: form.engineTypeValue, // Id do engine type
          IdCamp: form.IdCamp,
          EngDescription: form.EngDescription, // Campo descrição
          Limit: form.Limit,
          Bonus: form.Bonus,
          Priority: form.Priority,
          IdEngineCalendar: form.calendarValue, // 
          IdEngTemplate: form.templateValue,

          IdCampEngine: id.toString(), // ID da engine
          type: "engineModify",
          authx: ''
        }),
        engine: JSON.stringify({
          "1": [
            {
              IdTransformer: form.transformersValue,
              IdCampEngine: id,
              IdEngDirect: form.idEngDirect
            }]

        })
      }).then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
        .catch(function (error) {
          console.log(error);
        });

    } else if (form.engineTypeValue === '2' && sumValues <= 100) {
      api.post(url, {
        data0: {
          Algorithm: form.Algorithm, // Label engine type
          Active: form.Active, // Não tem alteração
          IdEngAlgorithm: form.engineTypeValue, // Id do engine type
          IdCamp: form.IdCamp,
          Campaign: form.Campaign,
          IdEngineCalendar: form.IdEngineCalendar, // 
          Calendar: form.Calendar, // Campo Calendar
          campaignActive: form.campaignActive, // Não tem alteração
          EngDescription: form.EngDescription, // Campo descrição
          IdEngTemplate: form.templateValue,
          IdCampEngine: id.toString(), // ID da engine
          type: "engineModify",
          authx: ''
        },
        engine: {
          "2": newForm
        }
      })
        .then(function (res) {
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setAlert({ msg: 'Sum of all Transformers must be in max 100', status: 'Error' })
    }
  }

  const handleActive = (id, active) => {
    api.post(url, {
      type: 'activeEngine',
      IdEng: id,
      active: active ? '1' : '0',
      authx: ''
    })
      .then(function (res) {
        res.data.status === 'ko' && setShowAlert(true)
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Campaign.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCampEngine.toString().includes(e.target.value) ||
        row.EngDescription.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Engines</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <BasicTable type={'engines'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} handleActive={handleActive} />
      <Modal isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setIsValidate(false)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <h1>Engine</h1>

          <Divider className='divider' variant="middle" />
          <Stack sx={{ gap: '.8rem' }}>

            <Autocomplete
              disabled={true}
              size='medium'
              options={form.templateList}
              getOptionLabel={(option) => option.Template}
              value={form.templateList.find(e => e.IdEngTemplate === form.templateValue)}
              onChange={(e, value) => {
                setForm({ ...form, templateValue: value.IdEngTemplate })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Template"
                />
              )}
            />

            <SelectMui
              label="Engine Type"
              width={'max'}
              size={'medium'}
              values={form.engineType}
              state={form.engineTypeValue}
              onChange={(e, val) => {
                setForm({ ...form, engineTypeValue: e.target.value, Algorithm: val.props.children })
              }}

            />

            <TextField label="Description" variant="outlined"
              // helperText={error.EngDescription ? "Incorrect entry." : ""}
              // error={error.EngDescription}
              value={form.EngDescription}
              onChange={(e) => {
                setForm({
                  ...form,
                  EngDescription: e.target.value
                })
              }} />

            <TextField label="Limit" variant="outlined"
              helperText={form.Limit === '' && isValidate ? "Incorrect entry." : ""}
              error={form.Limit === '' && isValidate}
              value={form.Limit}
              onChange={(e) => {
                setForm({
                  ...form,
                  Limit: e.target.value
                })
              }} />

            <TextField label="Bonus" variant="outlined"
              helperText={form.Bonus === '' && isValidate ? "Incorrect entry." : ""}
              error={form.Bonus === '' && isValidate}
              value={form.Bonus}
              onChange={(e) => {
                setForm({
                  ...form,
                  Bonus: e.target.value
                })
              }} />

            <TextField label="Priority" variant="outlined"
              helperText={form.Priority === '' && isValidate ? "Incorrect entry." : ""}
              error={form.Priority === '' && isValidate}
              value={form.Priority}
              onChange={(e) => {
                setForm({
                  ...form,
                  Priority: e.target.value
                })
              }} />

            <SelectMui
              label="Calendar"
              width={'max'}
              size={'medium'}
              values={form.calendarList}
              state={form.calendarValue}
              onChange={(e, val) => {
                setForm({ ...form, calendarValue: e.target.value })
              }}

            />

            <h2>{form.engineTypeValue === '1' ? 'Direct' : 'DISTRIBUTION BY WEIGHT'}</h2>
            {
              form.engineTypeValue === '1' ?
                <Autocomplete
                  size='medium'
                  options={form?.transformers}
                  getOptionLabel={(option) => option.Company}
                  onChange={(e, value) => {
                    setForm({
                      ...form,
                      transformersValue: value.IdCompany
                    })
                  }}
                  value={form.transformers.find(e => e.IdCompany === form.transformersValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transformer"
                    />
                  )}
                /> : form.transformers?.map((ele) => {
                  return <TextField label={ele.Company} variant="outlined"
                    helperText={form.calendar ? "Incorrect entry." : ""}
                    key={ele.IdCompany}
                    value={formWeight[ele.IdCompany]?.Weight !== undefined ? formWeight[ele.IdCompany].Weight : ''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PercentIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      (/^[1-9][0-9]?$|^100$/.test(e.target.value) || e.target.value === '') && setFormWeight({
                        ...formWeight,
                        [ele.IdCompany]: { Weight: e.target.value.replace(/\D/g, "") }
                      })
                    }} />
                })}
            <Button onClick={() => {
              if (validation()) {
                confirmUpdateForm()
                setShowAlert(!showAlert)
              } else {
                console.log(form);
              }
            }} variant="contained">{'Update'}</Button>
          </Stack>
        </AddModal>
      </Modal>

      {/* Modal de alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Updating Engines</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h2>Error code {alert.code}</h2>
              <h3>:&#40;	</h3>
              <p>{alert.msg}</p>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>}
      </ModalAlert>
    </TableBar >
  );
}

export default Engines;